import { PageId } from 'constants/pages'

export const enum PageIdStylioArch71 {
  SUBSCRIPTIONS_ARCH_71 = PageId.SUBSCRIPTIONS_ARCH_71,
  SUB_UPSELL_ARCH_71 = PageId.SUB_UPSELL_ARCH_71,
  FACE_STYLING_PDF_UPSELL_ARCH_71 = PageId.FACE_STYLING_PDF_UPSELL_ARCH_71,
  PROPORTIONS_PDF_UPSELL_ARCH_71 = PageId.PROPORTIONS_PDF_UPSELL_ARCH_71,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
  DOWNLOAD_ARCH_71 = PageId.DOWNLOAD_ARCH_71,
}
